import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "item-detail"
}
const _hoisted_2 = { class: "row detail-method-row" }
const _hoisted_3 = { class: "detail-method-col mb-3" }
const _hoisted_4 = {
  class: "key",
  style: {"font-weight":"bold"}
}
const _hoisted_5 = { class: "detail-method-col" }
const _hoisted_6 = { class: "prop" }
const _hoisted_7 = {
  key: 0,
  class: "prop no-info"
}

import { onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'item-detale',
  props: {
  item: {
    type: Object,
    default: () => ({ Text: "", Value: null }),
  },
},
  setup(__props) {

const props = __props;

// const innerItem = computed(() => props.item.value);

onMounted(() => {
  // Called when the component is mounted
  // console.log("Component is mounted.");
});

// const changeMessage = () => {
//   props.msg = "New message!";
//   emits("update:message", props.msg);
// };

return (_ctx: any,_cache: any) => {
  return (__props.item?.Value || __props.item?.Value == 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "title", {}, () => [
                _createTextVNode(_toDisplayString(__props.item.Text), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                _createTextVNode(_toDisplayString(__props.item.Value), 1)
              ])
            ]),
            (!__props.item || (!__props.item.Value && __props.item.Value != 0))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, " нет данных "))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})